"use client"
import Link from "next/link"
import Image from "next/image"
import Carousel from "@/app/components/atomic/molecules/Carousel"
import {parseWpDate} from "@/app/utils/wp-utils"

export interface ILastPost {
    link: string
    h1: string
    date: string
    mediaLink?: string | null
    excerpt?: string
}

function formatPostDate(dateStr: string): string {
    const date = parseWpDate(dateStr)
    return isNaN(date.getTime()) ? "—" : date.toLocaleDateString("fr-FR")
}

function PostCard({post}: { post: ILastPost }) {
    return (
        <Link
            href={post.link}
            className="flex flex-col h-[200px] w-full bg-white rounded-2xl overflow-hidden"
        >
            {post.mediaLink ? (
                <div className="relative h-[85px] w-full">
                    <Image
                        src={post.mediaLink}
                        alt={post.h1}
                        fill
                        sizes="(max-width: 1024px) 100vw, 25vw"
                        quality={70}
                        className="object-cover rounded-t-2xl"
                    />
                </div>
            ) : (
                <div className="h-[85px] w-full bg-gray-100 rounded-t-2xl"/>
            )}

            <div className="flex flex-col justify-between flex-1 p-4">
                <div className="flex flex-col gap-1">
                    <h3 className="text-sm font-semibold line-clamp-2">
                        {post.h1}
                    </h3>
                </div>

                {post.date &&
                    <span className="text-xs text-rm-gray">
                        {formatPostDate(post.date)}
                    </span>
                }
            </div>
        </Link>
    )
}

export default function PostsCarousel({lastPosts, postsPerPages = 4}: { lastPosts: ILastPost[], postsPerPages?: number }) {
    const items = lastPosts.map((post) => (
        <PostCard key={post.link} post={post}/>
    ))

    return <Carousel items={items} lgPerPage={postsPerPages}/>
}
